import { render } from "./InvitationLanding.vue?vue&type=template&id=296ade78&scoped=true"
import script from "./InvitationLanding.vue?vue&type=script&lang=js"
export * from "./InvitationLanding.vue?vue&type=script&lang=js"

import "./InvitationLanding.vue?vue&type=style&index=0&id=296ade78&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296ade78"]])

export default __exports__